export default __webpack_public_path__ + "static/media/title.f8a80ea2.svg";